<template>
    <tr>
        <td>
            <label :for="'product' + product.id" class="checkbox">
                <input
                    :id="'product' + product.id"
                    type="checkbox"
                    :checked="isSelected"
                    @change="updateProduct(product)"
                >
                <span />
                {{ product.internal_name }}
            </label>
        </td>
        <td class="text-right">
            <span v-if="formattedSetupFee">
                {{ formattedSetupFee }} kr
            </span>
        </td>
        <td class="text-right">
            <span v-if="product.contract_length">
                {{ product.contract_length }} månader
            </span>
        </td>
        <td class="text-right">
            <span v-if="formattedMonthlyCost">
                {{ formattedMonthlyCost }} kr/mån
            </span>
        </td>
    </tr>
</template>

<script>
    import { thousandFormatter } from '../../../../../shared/mixins/ThousandFormatter';

    export default {
        props: {
            selectedProducts: {
                required: true,
                type: Array,
            },
            product: {
                required: true,
                type: Object,
            },
            updateProduct: {
                required: true,
                type: Function,
            },
        },

        computed: {
            isSelected() {
                return this.selectedProducts.findIndex(selectedTeam => selectedTeam.id === this.product.id) >= 0;
            },
            formattedSetupFee() {
                if (! this.product.installation_fee) {
                    return '';
                }

                return thousandFormatter(this.product.installation_fee);
            },
            formattedMonthlyCost() {
                if (! this.product.monthly_fee) {
                    return '';
                }

                return thousandFormatter(this.product.monthly_fee);
            },
        },
    };
</script>
